import type { ReactNode } from 'react';
import { cn } from '@/shared/utils/cn';

interface PdpSectionCardProps {
  children: ReactNode;
  className?: string;
  id?: string;
}

export function PdpSectionCard({ children, className, id }: PdpSectionCardProps) {
  return (
    <section
      id={id}
      className={cn(
        'rounded-lg bg-white p-4 shadow-[0_1px_4px_rgba(0,0,0,0.06)]',
        className
      )}
    >
      {children}
    </section>
  );
}
